import { Phone } from "lucide-react";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const Eyebrow = ({ children }) => <div className="font-mono-tech text-xs tracking-[0.3em] uppercase amber mb-3">{children}</div>;

export const CallButtons = ({ wa, id }) => (
  <div className="flex flex-wrap gap-3">
    <a href="tel:+390587484791" className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-[#E63946] hover:bg-[#D62828] text-white font-semibold transition-colors" data-testid={`${id}-call`}>
      <Phone className="w-5 h-5" /> Chiama 0587 484791
    </a>
    <a href={wa} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-[#25D366] hover:bg-[#1EBE5A] text-white font-semibold transition-colors" data-testid={`${id}-whatsapp`}>
      <WhatsAppIcon className="w-5 h-5" /> Preventivo su WhatsApp
    </a>
  </div>
);

export const PhotoHero = ({ img, eyebrow, title, text, wa, id }) => (
  <section className="relative pt-20 overflow-hidden" data-testid={`${id}-hero`}>
    <div className="absolute inset-0">
      <img src={img} alt="" className="w-full h-full object-cover opacity-35" />
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/75 to-background/30" />
    </div>
    <div className="relative max-w-7xl mx-auto px-6 py-24 lg:py-36">
      <div className="max-w-3xl fade-up">
        <Eyebrow>{eyebrow}</Eyebrow>
        <h1 className="font-display text-[1.6rem] sm:text-5xl lg:text-6xl font-extrabold tracking-tight uppercase leading-none break-words" data-testid={`${id}-h1`}>{title}</h1>
        <p className="text-base sm:text-lg text-slate-300 leading-relaxed mt-6 max-w-xl">{text}</p>
        <div className="mt-10"><CallButtons wa={wa} id={id} /></div>
      </div>
    </div>
  </section>
);

export const Steps = ({ steps, id }) => (
  <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid={`${id}-steps`}>
    {steps.map(([t, d], i) => (
      <li key={t} className="relative rounded-2xl bg-[#181A22] border border-white/10 p-6 fade-up" style={{ animationDelay: `${i * 80}ms` }}>
        <div className="font-display text-5xl font-extrabold text-[#E63946]/25 leading-none mb-3">0{i + 1}</div>
        <h3 className="font-display font-bold text-lg mb-2">{t}</h3>
        <p className="text-sm text-muted-foreground leading-relaxed">{d}</p>
      </li>
    ))}
  </ol>
);
